import Highcharts from 'highcharts';
import { filterByCategory } from '../ranking-sm/data.js';

export function getPoliceData() {
    const categories = [
        'Mandaty: liczba wystawionych dot. PRD',
        'Liczba mieszkańców',
        'Policja: mandaty ogółem',
        'Policja: mandaty parkowanie',
        'Policja: pouczenia ogółem',
        'Policja: pouczenia parkowanie',
        'Policja: wykroczenia ogółem',
        'Policja: wykroczenia parkowanie',
    ];
    const data = filterByCategory(categories);

    const parkingRatio = data.filter(d =>
        d['Policja: mandaty ogółem'] > 0 &&
        d['Policja: mandaty parkowanie'] > 0
    ).reduce((acc, d) => {
        acc.general += d['Policja: mandaty ogółem']
        acc.parking += d['Policja: mandaty parkowanie']
        return acc;
    }, { general: 0, parking: 0 });

    const offenceRatio = data.filter(d =>
        d['Policja: wykroczenia parkowanie'] > 0 &&
        d['Policja: mandaty parkowanie'] > 0
    ).reduce((acc, d) => {
        acc.offence += d['Policja: wykroczenia parkowanie']
        acc.parking += d['Policja: mandaty parkowanie']
        return acc;
    }, { offence: 0, parking: 0 });

    data.forEach(d => {
        if (!d['Policja: mandaty parkowanie']) {
            if (d['Policja: mandaty ogółem']) {
                d['Policja: mandaty parkowanie'] = d['Policja: mandaty ogółem'] * parkingRatio.parking / parkingRatio.general
                d.estimated = true
            }
            if (d['Policja: wykroczenia parkowanie']) {
                d['Policja: mandaty parkowanie'] = Math.max(d['Policja: mandaty parkowanie'] || 0, d['Policja: wykroczenia parkowanie'] * offenceRatio.parking / offenceRatio.offence)
                d.estimated = true
            }
        }
    })

    data.forEach(sm => {
        sm.policeFines = sm['Policja: mandaty parkowanie'] || 0;
        sm.smFines = sm['Mandaty: liczba wystawionych dot. PRD'] || 0;
        sm.policeFinesPer100k = Math.round(sm.policeFines / sm['Liczba mieszkańców'] * 100000);
        sm.smFinesPer100k = Math.round(sm.smFines / sm['Liczba mieszkańców'] * 100000);
    });

    return data.sort((a, b) => b.smFinesPer100k - a.smFinesPer100k);
}

export default function chartPolice(id) {
    if (!document.getElementById(id)) return;
    const data = getPoliceData();

    const policeColor = '#3498db';
    const categories = data.map(item => item.city);
    const policeSeries = data.map(item => ({
        y: item.policeFinesPer100k,
        color: item.estimated ? '#b1b1b1ff' : policeColor
    }));
    const smSeries = data.map(item => item.smFinesPer100k);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Parking fines per 100k residents' },
        subtitle: { text: 'Comparison of city guard and police activity' },
        xAxis: {
            categories: categories,
            type: 'category',
            title: { text: null },
            labels: { style: { fontSize: '16px' } }
        },
        yAxis: [{
            title: { text: null },
            labels: { style: { color: '#999' } },
            opposite: true
        }, {
            min: 0,
            title: { text: null },
            labels: { style: { color: policeColor } }
        }],
        tooltip: { valueSuffix: ' per 100k residents' },
        legend: { enabled: true, verticalAlign: 'top', align: 'center' },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.series.name === 'City Guard') {
                            return Math.round(this.y || 0);
                        } else {
                            return this.y;
                        }
                    }
                }
            },
            series: { grouping: false, borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'City Guard',
            data: smSeries,
            color: '#018b1388'
        }, {
            name: 'Police (grey – estimated data)',
            data: policeSeries,
            color: policeColor,
            pointPlacement: -0.2
        }]
    });
}
